module.exports = __webpack_public_path__ + "img/logo.c133c855.png";